import { useMemo } from "react";
import { useActiveLang } from "./use-active-lang";
import deepcopy from 'deepcopy';
import { applyLangTo } from "@shapeable/utils";
import { useEnv } from "./use-env";
export function useApplyLang(obj) {
  var lang = useActiveLang();
  var env = useEnv();
  return useMemo(function () {
    if (env.ENABLE_LANG && lang && lang.iso !== (env.DEFAULT_LANG || 'en')) {
      var o = deepcopy(obj);
      return applyLangTo(o, lang.iso);
    }
    return obj;
  }, [lang, obj]);
}